module.exports = __webpack_public_path__ + "img/stone_dark_grey_ba_list.8cf7bbf4.jpg";